import {
  ADD_WARNING,
  ADD_ERROR,
  CLOSE_WARNING,
  CLOSE_ERROR,
  SHOW_FINISHED_ARTWORK_INFO,
  CLOSE_FINISHED_ARTWORK_INFO,
} from '@app/actions/_types';

export const closeWarning = () => ({
  type: CLOSE_WARNING,
});

export const closeError = () => ({
  type: CLOSE_ERROR,
});

export const addWarning = (locKey = '', payload = {}) => ({
  type: ADD_WARNING,
  payload: {
    locKey,
    ...payload,
  },
});

export const addError = (locKey = '', payload = {}) => ({
  type: ADD_ERROR,
  payload: {
    locKey,
    ...payload,
  },
});

export const showFinishedArtworkInfo = artworkInfo => ({
  type: SHOW_FINISHED_ARTWORK_INFO,
  payload: artworkInfo,
});

export const closeFinishedArtworkInfo = () => ({
  type: CLOSE_FINISHED_ARTWORK_INFO,
});
